import { useMutation } from "@tanstack/react-query";

import * as subscriptionApi from "@core/apis/subscription.api";
import type { CommonUseMutationOptions } from "@core/types/app";
import type { BillingKeyRequest, Subscription } from "@core/types/subscription";

export default (
  options?: CommonUseMutationOptions<BillingKeyRequest, Subscription>
) => {
  const mutation = useMutation({
    ...options,
    mutationFn: (params: BillingKeyRequest) =>
      subscriptionApi.createSubscription(params),
  });

  return mutation;
};
